export enum RepeatEndsOption {
  NEVER = 'Never',
  ON = 'On',
  AFTER = 'After'
}

export const REPEAT_ENDS_OPTIONS = Object.keys(RepeatEndsOption).map((i) => RepeatEndsOption[i]);
